import { render, staticRenderFns } from "./Orderer.vue?vue&type=template&id=2f149e12&"
import script from "./Orderer.vue?vue&type=script&lang=js&"
export * from "./Orderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports